import { render, staticRenderFns } from "./PrimaryCTA.vue?vue&type=template&id=7f11532b"
import script from "./PrimaryCTA.vue?vue&type=script&lang=js"
export * from "./PrimaryCTA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports